export default {
  navText: '导航',
};
